import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import Loader from '../../../common/Loader.js'
import CustomFooter from '../../../common/TableBottom.js'
class BookingHistory extends React.Component {
  state = {
    isData: false,
    listCountries: [],
    bookingList: [],
    limit: 10,
    pageNumber: 0,
    totalPages: 0,
    disabled: false,
  }

  componentDidMount() {
    if (this.props.customer_id) {
      this.getBookingHistory()
    }
  }

  getBookingHistory = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/user-booking-history/' + this.props.customer_id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          limit: this.state.limit,
          pageNumber: this.state.pageNumber,
          country: this.state.country,
          booking_status: this.state.bookingStatus,
          keyword: this.state.keyword,
          chaletId: this.state.chaletId,
          type_tag: this.state.type_tag,
        },
      })
      .then((res) => {
        if (res.data.success) {
          res.data.data.forEach((booking) => {
            if (booking.booking_status == 'Cancelled' || booking?.booking_cancel) {
              booking.booking_status = 'Cancelled'
            } else if (booking.booking_status == 'Pending' && booking.payment_status == true) {
              booking.booking_status = 'Pending'
            }
          })

          this.setState({
            bookingList: res.data.data,
            totalPages: res.data?.pagination?.totalPages,
            disabled: Object.keys(res.data?.pagination?.next).length == 0,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  debounceTimeout = null

  onSearch = (event) => {
    this.setState(
      {
        keyword: event.target.value,
        pageNumber: 0,
      },
      () => {
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

        this.debounceTimeout = setTimeout(() => {
          this.getBookingHistory()
        }, 500)
      }
    )
  }

  clearSearch = () => {
    this.setState(
      {
        keyword: '',
        pageNumber: 0,
      },
      () => {
        this.getBookingHistory()
      }
    )
  }

  render() {
    const customSearchRender = (searchText, handleSearch, hideSearch) => {
      return (
        <div className="container">
          <div className="d-flex justify-content-around">
            <i className="f-16 icofont icofont-search m-t-10 m-r-10"></i>
            <input
              type="search"
              className="form-control custom-input-search"
              placeholder="Search Booking"
              value={this.state.keyword}
              name="keyword"
              onChange={this.onSearch}
            />
            <span
              className="pointer m-t-5"
              style={{ cursor: 'pointer' }}
              onClick={() => {
                this.clearSearch(hideSearch)
              }}
            >
              <i className="f-24 icofont icofont-close m-l-10"></i>
            </span>
          </div>
        </div>
      )
    }

    const columns = [
      {
        name: 'order_number',
        label: 'Order No.',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'type',
        label: 'Type of booking.',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return (
              <span>
                {data == 'Chalet Booking'
                  ? 'Chalet'
                  : data == 'Cruise Booking'
                    ? 'Cruise'
                    : data == 'Event Booking'
                      ? 'Event'
                      : 'Booking'}
              </span>
            )
          },
        },
      },
      {
        name: 'total_amount',
        label: 'Amount',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'booking_date',
        label: 'Booking Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return <span>{data || '--'}</span>
          },
        },
      },
      {
        name: 'booking_status',
        label: 'Booking Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return <span>{data || '--'}</span>
          },
        },
      },
      {
        name: 'coupon_applied_amount',
        label: 'Coupon Applied Amount',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (data) => {
            return <span>{data || '--'}</span>
          },
        },
      },
      {
        name: 'country',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'booking_id',
        label: 'Details',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (booking_id, { rowData }) => {
            return (
              <div>
                {rowData[1] == 'Cruise Booking' && (
                  <div>
                    <Link
                      to={'/booking-ordering/' + booking_id}
                      className="m-r-15 text-muted"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="View "
                    >
                      <i className="f-22 icofont icofont-eye text-dark"></i>
                    </Link>
                  </div>
                )}
                {rowData[1] == 'Event Booking' && (
                  <div>
                    <Link
                      to={'/new-evt/' + booking_id}
                      className="m-r-15 text-muted"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="View "
                    >
                      <i className="f-22 icofont icofont-eye text-dark"></i>
                    </Link>
                  </div>
                )}
                {rowData[1] == 'Chalet Booking' && (
                  <div>
                    <Link
                      to={'/chalet-booking-details/' + booking_id}
                      className="m-r-15 text-muted"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-original-title="View "
                    >
                      <i className="f-22 icofont icofont-eye text-dark"></i>
                    </Link>
                  </div>
                )}
              </div>
            )
          },
        },
      },
    ]

    const options = {
      // filterType: "dropdown",
      viewColumns: false,
      print: false,
      download: false,
      filter: false,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            count={this.state.limit}
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
            bookingList: [],
          },
          () => {
            this.getBookingHistory()
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            bookingList: [],
          },
          () => {
            this.getBookingHistory()
          }
        )
      },
      customSearchRender: customSearchRender,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? <Loader open={this.state.isLoading} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="page-body">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-block">
                <div className="dt-responsive table-responsive">
                  <MUIDataTable
                    title={'Booking History'}
                    className="table-responsive"
                    data={this.state.bookingList}
                    columns={columns}
                    options={options}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BookingHistory
